import { NotaFiscalDevolucao } from "app/types/pesquisa-orcamento/consultas/Devolucoes";
import { BaseApi } from "./BaseApi";
import { ItensDevolucao } from "app/types/pesquisa-orcamento/consultas/sub-consultas-devolucoes/Itens";
import { CreditoDevolucoes } from "app/types/pesquisa-orcamento/consultas/sub-consultas-devolucoes/CreditoDevolucoes";


export class NotaFiscalEntradaApi extends BaseApi {

    async ListarDevolucoes(numeroOrcamento: number): Promise<NotaFiscalDevolucao[]> {
        const resposta = await this.api.post(`/NotaFiscalEntrada/NotasFiscais`, {
            numeroOrcamento
        })

        return resposta?.data
    }

    async Itens(codigoNotaFiscal: number): Promise<ItensDevolucao[]> {
        const resposta = await this.api.post(`/NotaFiscalEntrada/Itens`, {
            codigoNotaFiscal
        })

        return resposta?.data
    }

    async ContasPagar(codigoNotaFiscal: number): Promise<any> {
        const resposta = await this.api.post(`/NotaFiscalEntrada/ContasPagar`, {
            codigoNotaFiscal
        })

        return resposta?.data
    }

    async CreditoDevolucao(codigoNotaFiscal: number): Promise<CreditoDevolucoes[]> {
        const resposta = await this.api.post(`/NotaFiscalEntrada/CreditoDevolucao`, {
            codigoNotaFiscal
        })

        return resposta?.data
    }

}
